import styled from 'styled-components';
import { Box, List } from '@bynder/design-system';

export const FullWidthBox = styled(Box)`
    flex: 1;
    max-width: 237px;
`;

export const HiddenInput = styled.input`
    width: 1px;
    height: 1px;
    opacity: 0;
    margin: 0;
    padding: 0;
`;

export const StyledListItem = styled(List.Item)<{ isDisabled: boolean }>`
    min-width: 335px;
    ${({ isDisabled }) =>
        isDisabled
            ? `
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.5;
    `
            : ''}
`;
